angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "FORM_ERRORS": {
    "COMMON": {
      "REQUIRED": "This field is required"
    },
    "NAME": {
      "MIN_LENGTH": "Your name must contain at least 2 characters",
      "MAX_LENGTH": "Your name must not exceed 20 characters"
    },
    "EMAIL": {
      "PATTERN": "Invalid email address",
      "UNIQUE": "Email already exists"
    },
    "PASSWORD": {
      "MIN_LENGTH": "Your password must contain at least 6 characters",
      "MAX_LENGTH": "Your password must not exceed 40 characters",
      "MATCH": "Passwords do not match"
    },
    "CAPTCHA": {
      "VALID": "Captcha verification has failed"
    }
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/nls/form_errors.json
// module id = 83
// module chunks = 24